const arMessages = {
    datepicker: {
        toggleCalendar: 'فتح/إغلاق التقويم'
    },
    calendar: {
        today: 'اليوم'
    },
    dateinput: {
        increment: 'زيادة القيمة',
        decrement: 'تقليل القيمة'
    },
    numerictextbox: {
        increment: 'زيادة القيمة',
        decrement: 'تقليل القيمة'
    },
    grid: {
        groupPanelEmpty: 'اسحب رأس العمود وأفلته هنا لتجميع حسب هذا العمود',
        noRecords: 'لم يتم العثور على بيانات.',
        pagerFirstPage: 'الانتقال إلى الصفحة الأولى',
        pagerPreviousPage: 'الانتقال إلى الصفحة السابقة',
        pagerNextPage: 'الانتقال إلى الصفحة التالية',
        pagerLastPage: 'الانتقال إلى الصفحة الأخيرة',
        pagerPage: 'صفحة',
        pagerOf: ' / ',
        pagerTotalPages: '{0}',
        pagerItems: 'عنصر',
        pagerInfo: '{0} - {1} / {2} عنصر',
        pagerItemsPerPage: 'عناصر لكل صفحة',
        filterEqOperator: 'يساوي',
        filterNotEqOperator: 'لا يساوي',
        filterIsNullOperator: 'فارغ (null)',
        filterIsNotNullOperator: 'ليس فارغ (ليس null)',
        filterIsEmptyOperator: 'فارغ',
        filterIsNotEmptyOperator: 'ليس فارغ',
        filterStartsWithOperator: 'يبدأ بـ',
        filterContainsOperator: 'يحتوي على',
        filterNotContainsOperator: 'لا يحتوي على',
        filterEndsWithOperator: 'ينتهي بـ',
        filterGteOperator: 'أكبر من أو يساوي',
        filterGtOperator: 'أكبر من',
        filterLteOperator: 'أصغر من أو يساوي',
        filterLtOperator: 'أصغر من',
        filterIsTrue: 'غير نشط',
        filterIsFalse: 'نشط',
        filterBooleanAll: '(الكل)',
        filterAfterOrEqualOperator: 'بعد أو يساوي',
        filterAfterOperator: 'بعد',
        filterBeforeOperator: 'قبل',
        filterBeforeOrEqualOperator: 'قبل أو يساوي',
        filterSubmitButton: 'تصفية',
        filterClearButton: 'مسح المرشحات',
        filterAndLogic: 'و',
        filterOrLogic: 'أو',
        filterTitle: 'تصفية',
        sortAscending: 'ترتيب تصاعدي',
        sortDescending: 'ترتيب تنازلي',
        searchPlaceholder: 'بحث',
        filterCheckAll: 'تحديد الكل',
        pagerItemPerPage: 'عناصر لكل صفحة',
        filterChooseOperator: 'اختر المشغل',
        filterSelectedItems: 'العناصر المحددة',
        filterAriaLabel: 'تصفية',
        sortAriaLabel: 'قابل للترتيب',
        groupColumn: 'عمود المجموعة',
        groupExpand: 'توسيع المجموعة',
        groupCollapse: 'طي المجموعة',
        groupPanelAriaLabel: 'لوحة المجموعة',
        ungroupColumn: 'إلغاء تجميع العمود',
        detailExpand: 'توسيع صف التفاصيل',
        detailCollapse: 'طي صف التفاصيل'
    }
};
export default arMessages;
